import React from "react";
import NavbarClass from "../NavbarClass";
import Footer from "../footer/Footer";
import { fetchPublicBlogs } from "../../actions/publicBlogActions";
import { connect } from "react-redux";
import SkeletonCardsList from "../skeleton-card/SkeletonCardsList";
import { pageview } from "../../utils/googleAnalyticsUtils";
import PublicBlogCard from "./PublicBlogCard";
import { InView } from "react-intersection-observer";

class PublicBlog extends React.Component {
  async componentDidMount() {
    pageview("Public Blogs");
    await this.props.fetchPublicBlogs();
  }

  state = {
    searchTerm: "",
    subscribeModalShow: false,
    imgsLoaded: 0,
  };

  onPublicBlogImgsLoad = () => {
    console.log(
      "publicBlog img load",
      this.state.imgsLoaded,
      this.props.publicBlogsCount
    );
    this.setState({
      imgsLoaded: this.state.imgsLoaded + 1,
    });
  };

  publicBlogCardsWrapperRef = React.createRef();

  render() {
    return (
      <div
        style={{
          position: "relative",
          minHeight: "100vh",
          // paddingBottom: "5.6rem",
        }}
      >
        <div>
          <NavbarClass handleSignInOpen={this.props.handleSignInOpen} />
        </div>
        <div className="container content-container-publicBlog-c">
          <div className="mt-5 publicBlog-content-heading-text">
            <h2 className="hp-section-heading">Blogs</h2>
          </div>

          <InView threshold={0.1} triggerOnce>
            {({ inView, ref }) => (
              <div ref={ref} className={`hp-animate hp-animate--up ${inView ? "is-visible" : ""}`}>
                {/* PublicBlog Cards */}
                <div
                  className="row publicBlog-list-inner-container"
                  style={
                    this.state.imgsLoaded >= this.props.publicBlogsCount
                      ? {}
                      : { display: "none" }
                  }
                >
                  {this.props.publicBlogs &&
                    this.props.publicBlogs?.length > 0 &&
                    this.props.publicBlogs
                      .filter((val) => {
                        if (
                          !this.props.searchEnabled ||
                          this.state.searchTerm === ""
                        ) {
                          return val;
                        } else if (
                          val.title
                            .toLowerCase()
                            .includes(this.state.searchTerm.toLowerCase())
                        ) {
                          return val;
                        } else {
                          return null;
                        }
                      })
                      .map((publicBlog, key) => (
                        <PublicBlogCard
                          key={key}
                          publicBlog={publicBlog}
                          handlePublicBlogThumbnailClick={this.handlePublicBlogThumbnailClick}
                          imgOnLoad={this.onPublicBlogImgsLoad}
                        />
                      ))}
                </div>
              </div>
            )}
          </InView>

          {/* Skeleton cards */}
          <div
            className="row publicBlog-list-inner-container"
            style={
              !this.state.imgsLoaded ||
              this.state.imgsLoaded >= this.props.publicBlogsCount
                ? { display: "none" }
                : {}
            }
          >
            <SkeletonCardsList
              count={this.props.publicBlogsCount ? this.props.publicBlogsCount : 5}
              width="14rem"
              height="9.5rem"
              borderRadius="5%"
            />
          </div>
        </div>
        <br />
        <br />
        <Footer customStyles={{ position: "absolute", bottom: 0 }}></Footer>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    publicBlogs: state.publicBlogs?.publicBlogs?.publicBlogs,
    publicBlogsCount: state.publicBlogs?.publicBlogs?.publicBlogsCount,
    userStatus: state.userLoggedinAndPremiumCheck,
  };
};

export default connect(mapStateToProps, {
  fetchPublicBlogs
})(PublicBlog);
